// import Partner from '@/views/register/partner/Partner'
// import GeneralDataPF from '@/views/register/partner/GeneralDataPF'
// import GeneralDataPJ from '@/views/register/partner/GeneralDataPJ'
// import GeneralDataProcurator from '@/views/register/partner/GeneralDataProcurator'
// import Documents from '@/views/register/Documents'
// import Address from '@/views/register/partner/Address'
// import Index from '@/views/Index.vue'
const Partner = () => import('@/views/register/partner/Partner');
const GeneralDataPF = () => import('@/views/register/partner/GeneralDataPF');
const GeneralDataPJ = () => import('@/views/register/partner/GeneralDataPJ');
const GeneralDataProcurator = () => import('@/views/register/partner/GeneralDataProcurator');
const Documents = () => import('@/views/register/Documents');
const Address = () => import('@/views/register/partner/Address');
const Index = () => import('@/views/Index.vue');

import getWhiteLabel from '@/utils/getWhiteLabel'

const partnerRouter = {
    path: '/partner',
    component: Index,
    name: 'register/partner',
    meta: {
        requiresAuth: true
    },
    children: [{
            name: 'client/company',
            path: ':idCNPJ',
            component: Partner,
            meta: {
                title: `${getWhiteLabel()} - Cadastro`,
                requiresAuth: true
            },
        },
        {
            name: 'client/company',
            path: ':idCNPJ/pf/:id/0',
            component: GeneralDataPF,
            meta: {
                title: `${getWhiteLabel()} - Cadastro`,
                requiresAuth: true
            },
        },
        {
            name: 'client/company',
            path: ':idCNPJ/pf/new',
            component: GeneralDataPF,
            meta: {
                title: `${getWhiteLabel()} - Cadastro`,
                requiresAuth: true
            },
        },
        {
            name: 'client/company',
            path: ':idCNPJ/pf/:id/1',
            component: Documents,
            meta: {
                title: `${getWhiteLabel()} - Cadastro`,
                requiresAuth: true
            },
        },
        {
            name: 'client/company',
            path: ':idCNPJ/pj/:id/0',
            component: GeneralDataPJ,
            meta: {
                title: `${getWhiteLabel()} - Cadastro`,
                requiresAuth: true
            },
        },
        {
            name: 'client/company',
            path: ':idCNPJ/pj/new',
            component: GeneralDataPJ,
            meta: {
                title: `${getWhiteLabel()} - Cadastro`,
                requiresAuth: true
            },
        },
        {
            name: 'client/company',
            path: ':idCNPJ/pj/:id/1',
            component: Address,
            meta: {
                title: `${getWhiteLabel()} - Cadastro`,
                requiresAuth: true
            },
        },
        {
            name: 'client/company',
            path: ':idCNPJ/pj/:id/2',
            component: Documents,
            meta: {
                title: `${getWhiteLabel()} - Cadastro`,
                requiresAuth: true
            },
        },
        {
            name: 'client/company',
            path: ':idCNPJ/procurator/0',
            component: GeneralDataProcurator,
            meta: {
                title: `${getWhiteLabel()} - Cadastro`,
                requiresAuth: true
            },
        },
        {
            name: 'client/company',
            path: ':idCNPJ/procurator/:id/0',
            component: GeneralDataProcurator,
            meta: {
                title: `${getWhiteLabel()} - Cadastro`,
                requiresAuth: true
            },
        },
        {
            name: 'client/company',
            path: ':idCNPJ/procurator/:id/1',
            component: Documents,
            meta: {
                title: `${getWhiteLabel()} - Cadastro`,
                requiresAuth: true
            },
        },
    ]

}

export default partnerRouter;